import { QueryValueType } from "@angular/compiler/src/core";
import { Injectable} from "@angular/core";
import {MotivoEncerramento} from '@tivic-team/manager-ts/dist/mob/entities/ait/motivo-encerramento.entity';
import { HttpGet, JSONData, Quark, Url, HttpResponse, HttpPost, HttpPut } from "sol-request-angular/dist/comunicacao";
import { IFilter } from "sol-request-angular/dist/comunicacao/interfaces/IFilter";
import { environment } from "src/environments/environment";

@Injectable()
export class MotivoEncerramentoController{
    constructor() {}

    async get(cdMotivoEncerramento: number): Promise<MotivoEncerramento>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/motivo/encerramentos/:cdMotivoEncerramento',
                    environment: environment,
                    pathParams: new JSONData({cdMotivoEncerramento: cdMotivoEncerramento})
                }),
            }),
            new HttpResponse(
                new MotivoEncerramento()
            )
        );

        return await quark.call();
    }

    async find(filtros?: IFilter): Promise<Array<MotivoEncerramento>>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id:'mob/motivo/encerramentos',
                    environment: environment,
                    filter: filtros
                }),
            }),
            new HttpResponse(
                new Array<MotivoEncerramento>()
            )
        );
        return await quark.call();
    }

    async create(motivoEncerramento: MotivoEncerramento): Promise<MotivoEncerramento>{
        let quark = new Quark(
            new HttpPost({
                url: new Url({
                    id: 'mob/motivo/encerramentos',
                    environment: environment
                }),
                data: new JSONData(motivoEncerramento)
            }),

            new HttpResponse(
                new MotivoEncerramento()
            )
        );
        return await quark.call();
    }

    async update(motivoEncerramento: MotivoEncerramento): Promise<MotivoEncerramento>{
        let quark = new Quark(
            new HttpPut({
                url: new Url({
                    id: 'mob/motivo/encerramentos/:cdMotivoEncerramento',
                    environment: environment,
                    pathParams: new JSONData({cdMotivoEncerramento: motivoEncerramento.cdMotivoEncerramento})
                }),
                data: new JSONData(motivoEncerramento)
            }),
            new HttpResponse(
                new MotivoEncerramento()
            )
        );
        return await quark.call();
    }
}

